((Drupal) => {
  "use strict";

  // Adds active class to selected radio buttons - Math and English.
  const modulesSubnavigation = (context) => {
    const checkboxContainer = context.querySelector(
      ".block-views-exposed-filter-blocklist-library-modules-page .form-radios"
    );
    if (!checkboxContainer) return;

    const toggleActiveClass = (radio) => {
      radio.parentElement.classList.toggle("active", radio.checked);
    };

    checkboxContainer.addEventListener("change", (event) => {
      if (event.target.type === "radio") {
        toggleActiveClass(event.target);
      }
    });

    checkboxContainer
      .querySelectorAll('input[type="radio"]')
      .forEach(toggleActiveClass);
  };

  Drupal.behaviors.modulesSubnavigation = {
    attach(context) {
      modulesSubnavigation(context);
    },
  };
})(Drupal);
